/**
 * Screen size breakpoints for responsive design
 * Used across the application for consistent responsive behavior
 */
export const SCREEN_BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1200
} as const;

/**
 * Type for screen breakpoint keys
 */
export type BreakpointKey = keyof typeof SCREEN_BREAKPOINTS;
